import axios from "axios";
import * as config from "../config";
import UserProfile from '../UserProfile';

export function getProvince() {
    var authorization = config.headerCallAPI
    var token = ''
    if (UserProfile.getUserdata()) {
        token = UserProfile.getUserdata().token
    }
    authorization.headers['Authorization'] = "Bearer " + token;
    return axios.get(config.urlComAPI + '/province', authorization)
        .then(res => {
            return res
        }).catch((error) => {
            // Error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return error.response.data.message
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the 
                // browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
}

export function getDistrict(data) {
    var authorization = config.headerCallAPI
    var token = ''
    if (UserProfile.getUserdata()) {
        token = UserProfile.getUserdata().token
    }
    authorization.headers['Authorization'] = "Bearer " + token;
    return axios.get(config.urlComAPI + '/amphur?province_id=' + data, authorization)
        .then(res => {
            return res
        }).catch((error) => {
            // Error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return error.response.data.message
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the 
                // browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
}

export function getSubDistrict(data) {
    var authorization = config.headerCallAPI
    var token = ''
    if (UserProfile.getUserdata()) {
        token = UserProfile.getUserdata().token
    }
    authorization.headers['Authorization'] = "Bearer " + token;
    return axios.get(config.urlComAPI + '/tumbon?district_id=' + data, authorization)
        .then(res => {
            return res
        }).catch((error) => {
            // Error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return error.response.data.message
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the 
                // browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
}

export function getRegion() {
    var authorization = config.headerCallAPI
    var token = ''
    if (UserProfile.getUserdata()) {
        token = UserProfile.getUserdata().token
    }
    authorization.headers['Authorization'] = "Bearer " + token;
    return axios.get(config.urlComAPI + '/region', authorization)
        .then(res => {
            return res
        }).catch((error) => {
            // Error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return error.response.data.message
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the 
                // browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
}

export function getTerritoryID(data) {
    var authorization = config.headerCallAPI
    var token = ''
    if (UserProfile.getUserdata()) {
        token = UserProfile.getUserdata().token
    }
    authorization.headers['Authorization'] = "Bearer " + token;
    return axios.get(config.urlAPI + '/search/territory?rID=' + data, authorization)
        .then(res => {
            return res
        }).catch((error) => {
            // Error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return error.response.data.message
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the 
                // browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
}

export function getTerritory() {
    var authorization = config.headerCallAPI
    var token = ''
    if (UserProfile.getUserdata()) {
        token = UserProfile.getUserdata().token
    }
    authorization.headers['Authorization'] = "Bearer " + token;
    return axios.get(config.urlAPI + '/territory', authorization)
        .then(res => {
            return res
        }).catch((error) => {
            // Error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return error.response.data.message
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the 
                // browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
}

export function getBrand() {
    var authorization = config.headerCallAPI
    var token = ''
    var data = { 'state': 'get' }
    if (UserProfile.getUserdata()) {
        token = UserProfile.getUserdata().token
    }
    authorization.headers['Authorization'] = "Bearer " + token;
    return axios.post(config.urlAPI + '/brand', data, authorization)
        .then(res => {
            return res
        }).catch((error) => {
            // Error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return error.response.data.message
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the 
                // browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
}